export default class CreatePartyCommand {
	static protocol = {}

	constructor() {
		// 1-bit command
	}
}
